import React, { useState, useEffect } from 'react';
import { Row, Col, Tab, Tabs } from 'react-bootstrap';
//import { TabAccordion } from 'src/shared/TabAccordion';
import MedicalPlan from './products/MedicalPlan';
import DentalPlan from './products/DentalPlan';
import VisionPlan from './products/VisionPlan';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import BottomSideBar from './bottom-sidebar/BottomSideBar';
/*import {
  setSelectedCheckedItems,
  setSelectedCheckedRowData,
} from '../../../../../redux/member/enrollmentPlanCompareSlice';
import { useDispatch, useSelector } from 'react-redux';*/
import './styles/product-selection.scss';

const ProductSelection = ({
  nextStep,
  prevStep,
  enrollmentFormData,
  setEnrollmentFormData,
  setShowComparePlans,
  setSelectedCompareProducts,
  setCompareTabName,
}) => {
  /*const { selectedCheckedItems, selectedCheckedRowData } = useSelector(
    ({ enrollmentPlanCompare }) => enrollmentPlanCompare,
  );
  const dispatch = useDispatch();*/
  const [selectedTab, setSelectedTab] = useState('');

  const [selectedCheckedItems, setSelectedCheckedItems] = useState([]);
  const [selectedCheckedRowData, setSelectedCheckedRowData] = useState([]);
  const [selectedProductData, setSelectedProductData] = useState(null);
  const [selectedEnrollMembers, setSelectedEnrollMembers] = useState(null);

  const [selectedCheckedDentalItems, setSelectedCheckedDentalItems] = useState(
    [],
  );
  const [selectedCheckedDentalRowData, setSelectedCheckedDentalRowData] =
    useState([]);

  const [selectedProductDentalData, setSelectedProductDentalData] =
    useState(null);
  const [selectedEnrollDentalMembers, setSelectedEnrollDentalMembers] =
    useState(null);

  const [selectedCheckedVisionItems, setSelectedCheckedVisionItems] = useState(
    [],
  );
  const [selectedCheckedVisionRowData, setSelectedCheckedVisionRowData] =
    useState([]);

  const [selectedProductVisionData, setSelectedProductVisionData] =
    useState(null);
  const [selectedEnrollVisionMembers, setSelectedEnrollVisionMembers] =
    useState(null);

  //console.log('selectedCheckedItems', selectedCheckedItems);
  //console.log('selectedCheckedRowData', selectedCheckedRowData);
  console.log('enrollmentFormData', enrollmentFormData);

  const [isTabClicked, setIsTabClicked] = useState(false);

  const tabClickHandler = (e) => {
    console.log('tabClickHandler', e);
    setSelectedTab(e);
    //dispatch(setSelectedCheckedItems([]));
    //dispatch(setSelectedCheckedRowData([]));
    setSelectedCheckedItems([]);
    setSelectedCheckedRowData([]);
    setSelectedCheckedDentalItems([]);
    setSelectedCheckedDentalRowData([]);
    setSelectedCheckedVisionItems([]);
    setSelectedCheckedVisionRowData([]);
    setIsTabClicked(true);
  };

  const getTitle = (title) => {
    return <span>{title}</span>;
  };

  const onSelectedProducts = (product) => {
    console.log('onSelectedProducts', product);
    setSelectedProductData({ ...product, productType: 'medical' });
  };

  const onSelectedEnrollMembers = (members) => {
    setSelectedEnrollMembers(members);
  };

  const onSelectedDentalProducts = (product) => {
    console.log('onSelectedDentalProducts', product);
    setSelectedProductDentalData({ ...product, productType: 'dental' });
  };

  const onSelectedEnrollDentalMembers = (members) => {
    setSelectedEnrollDentalMembers(members);
  };

  const onSelectedVisionProducts = (product) => {
    console.log('onSelectedVisionProducts', product);
    setSelectedProductVisionData({ ...product, productType: 'Vision' });
  };

  const onSelectedEnrollVisionMembers = (members) => {
    setSelectedEnrollVisionMembers(members);
  };

  console.log('ProductSelection selectedEnrollMembers', selectedEnrollMembers);
  console.log(
    'ProductSelection selectedEnrollDentalMembers',
    selectedEnrollDentalMembers,
  );
  console.log(
    'ProductSelection selectedEnrollVisionMembers',
    selectedEnrollVisionMembers,
  );

  const onProductSelectHandler = () => {
    setEnrollmentFormData({
      ...enrollmentFormData,
      products: {
        selectedMedicalProduct: selectedProductData,
        enrolledMedicalMember: selectedEnrollMembers,
        selectedDentalProduct: selectedProductDentalData,
        enrolledDentalMember: selectedEnrollDentalMembers,
        selectedVisionProduct: selectedProductVisionData,
        enrolledVisionMember: selectedEnrollVisionMembers,
      },
    });
    nextStep();
  };

  useEffect(() => {
    setSelectedTab('medical');
  }, []);

  console.log('selectedProductData', selectedProductData);
  console.log('enrollmentFormData', enrollmentFormData);

  return (
    <div className="product-selection-container">
      <div className="product-selection-header">
        <div>Products</div>
      </div>
      <div className="product-selection-content">
        <div>
          <Tabs
            activeKey={selectedTab}
            defaultActiveKey="medical"
            id="uncontrolled-tab-example"
            className="mb-3 tabs-class-product-selection"
            onSelect={tabClickHandler}
          >
            {(selectedTab === 'medical' || true) && (
              <Tab eventKey="medical" title={getTitle('Medical')}>
                <MedicalPlan
                  setSelectedCheckedItems={setSelectedCheckedItems}
                  selectedCheckedItems={selectedCheckedItems}
                  setSelectedCheckedRowData={setSelectedCheckedRowData}
                  selectedCheckedRowData={selectedCheckedRowData}
                  enrollmentFormData={enrollmentFormData}
                  setEnrollmentFormData={setEnrollmentFormData}
                  onSelectedProducts={onSelectedProducts}
                  onSelectedEnrollMembers={onSelectedEnrollMembers}
                  selectedTab="medical"
                  isTabClicked={isTabClicked}
                  setIsTabClicked={setIsTabClicked}
                />
                <BottomSideBar
                  selectedCheckedItems={selectedCheckedItems}
                  selectedCheckedRowData={selectedCheckedRowData}
                  setSelectedCheckedItems={setSelectedCheckedItems}
                  setSelectedCheckedRowData={setSelectedCheckedRowData}
                  setShowComparePlans={setShowComparePlans}
                  setSelectedCompareProducts={setSelectedCompareProducts}
                  selectedTab="medical"
                  setCompareTabName={setCompareTabName}
                />
              </Tab>
            )}
            {(selectedTab === 'dental' || true) && (
              <Tab eventKey="dental" title={getTitle('Dental')}>
                <DentalPlan
                  setSelectedCheckedItems={setSelectedCheckedDentalItems}
                  selectedCheckedItems={selectedCheckedDentalItems}
                  setSelectedCheckedRowData={setSelectedCheckedDentalRowData}
                  selectedCheckedRowData={selectedCheckedDentalRowData}
                  enrollmentFormData={enrollmentFormData}
                  setEnrollmentFormData={setEnrollmentFormData}
                  onSelectedProducts={onSelectedDentalProducts}
                  onSelectedEnrollMembers={onSelectedEnrollDentalMembers}
                  selectedTab="dental"
                  isTabClicked={isTabClicked}
                  setIsTabClicked={setIsTabClicked}
                />
                <BottomSideBar
                  selectedCheckedItems={selectedCheckedDentalItems}
                  selectedCheckedRowData={selectedCheckedDentalRowData}
                  setSelectedCheckedItems={setSelectedCheckedDentalItems}
                  setSelectedCheckedRowData={setSelectedCheckedDentalRowData}
                  setShowComparePlans={setShowComparePlans}
                  setSelectedCompareProducts={setSelectedCompareProducts}
                  selectedTab="dental"
                  setCompareTabName={setCompareTabName}
                />
              </Tab>
            )}
            {(selectedTab === 'vision' || true) && (
              <Tab eventKey="vision" title={getTitle('Vision')}>
                <VisionPlan
                  setSelectedCheckedItems={setSelectedCheckedVisionItems}
                  selectedCheckedItems={selectedCheckedVisionItems}
                  setSelectedCheckedRowData={setSelectedCheckedVisionRowData}
                  selectedCheckedRowData={selectedCheckedVisionRowData}
                  enrollmentFormData={enrollmentFormData}
                  setEnrollmentFormData={setEnrollmentFormData}
                  onSelectedProducts={onSelectedVisionProducts}
                  onSelectedEnrollMembers={onSelectedEnrollVisionMembers}
                  selectedTab="vision"
                  isTabClicked={isTabClicked}
                  setIsTabClicked={setIsTabClicked}
                />
                <BottomSideBar
                  selectedCheckedItems={selectedCheckedVisionItems}
                  selectedCheckedRowData={selectedCheckedVisionRowData}
                  setSelectedCheckedItems={setSelectedCheckedVisionItems}
                  setSelectedCheckedRowData={setSelectedCheckedVisionRowData}
                  setShowComparePlans={setShowComparePlans}
                  setSelectedCompareProducts={setSelectedCompareProducts}
                  selectedTab="vision"
                  setCompareTabName={setCompareTabName}
                />
              </Tab>
            )}
          </Tabs>
        </div>
      </div>
      <div className="ml4 mr-4 pb-4">
        <Row>
          <Col className="d-flex justify-content-end">
            <GenericButton
              variant="link"
              onClick={() => {
                prevStep();
              }}
              className="form-btn"
            >
              Back
            </GenericButton>
            <GenericButton
              type="button"
              className="mr-0"
              //disable={!selectedCheckedItems.length}
              //buttonDisabled={!selectedCheckedItems.length}
              /*disable={
                selectedProductData == null &&
                selectedProductDentalData == null &&
                selectedProductVisionData == null
              }
              buttonDisabled={
                selectedProductData == null &&
                selectedProductDentalData == null &&
                selectedProductVisionData == null
              }*/
              disable={
                (selectedEnrollMembers == null ||
                  selectedEnrollMembers.length === 0) &&
                (selectedEnrollDentalMembers == null ||
                  selectedEnrollDentalMembers.length === 0) &&
                (selectedEnrollVisionMembers == null ||
                  selectedEnrollVisionMembers.length === 0)
              }
              buttonDisabled={
                (selectedEnrollMembers == null ||
                  selectedEnrollMembers.length === 0) &&
                (selectedEnrollDentalMembers == null ||
                  selectedEnrollDentalMembers.length === 0) &&
                (selectedEnrollVisionMembers == null ||
                  selectedEnrollVisionMembers.length === 0)
              }
              onClick={() => onProductSelectHandler()}
            >
              Continue
            </GenericButton>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ProductSelection;
